import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import MessagingTriviaResultsResponses from "./Results/MessagingTriviaResultsResponses";
import MessagingTriviaResultsSummary from "./Results/MessagingTriviaResultsSummary";
import TriviaResultsRatings from "./TriviaResultsRatings";
import TriviaResultsResponses from "./TriviaResultsResponses";
import TriviaResultsSummary from "./TriviaResultsSummary";
import { withRouter } from "react-router-dom";
import { Redirect, Route, Switch } from "react-router";
import TriviaResultsInsights from "./TriviaResultsInsights";

function TriviaResultsComponent({ currentTrivia, ...props }) {
  const [tab, setTab] = useState(1);

  const planType = props.user.profile.organizationId.trivvyPlanType;

  useEffect(() => {
    const currentBlock = props.match.params.tab;

    if (currentBlock == "results-summary") {
      setTab(1)
    }
    if (currentBlock == "results-responses") {
      setTab(2)
    }
    if (currentBlock == "results-insights"  || currentBlock == "results") {
      setTab(3)
    }
  }, [])

  const changeTab = (tab) => {

    props.history.push(`results-${tab == 1 ? "summary" : tab == 2 ? "responses" : tab == 3 ? "insights" : "insights"}`);
    setTab(tab);
  };

  if (currentTrivia) {
    return (
      <div id={"trivvy_result_wrapper"}>
        <div>
          <Row className="bg-white top-trivia-results-row">
            <Col sm={2}></Col>
            <Col sm={8}>
              <div className="bg-white">
                <ul
                  className="data-user trivia-edit-top-nav-survey-ui"
                  style={{
                    width: isMobile ? "inherit" : "400px",
                    marginBottom:"-2px",
                    margin:"0 auto"
                  }}
                >
                  <li className="survey_top_div_padding_manage">
                    <a
                      className={`res_menu_option ${tab == 3 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(3)}
                      style={{
                        width: isMobile ? "inherit" : "200px",
                      }}
                    >
                      Insights
                    </a>
                  </li>

                  {
                    !currentTrivia.isMessaging &&  <li>
                    <a
                      className={`res_menu_option ${tab == 1 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(1)}
                      style={{
                        width: isMobile ? "inherit" : "200px",
                      }}
                    >
                      By Question
                    </a>
                  </li>
                  }

                 

                  <li>
                    <a
                      className={`res_menu_option ${tab == 2 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(2)}
                      style={{
                        width: isMobile ? "inherit" : "200px",
                      }}
                    >
                      By User
                    </a>
                  </li>


                  {/* <li>
                    <a
                      className={`${
                        tab == 3 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => changeTab(3)}
                    >
                      Rating
                    </a>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col sm={2}></Col>
          </Row>
        </div>
        <Row className="TriviaResultsResponsesContainer trivia_results_section_ui_height_wrapper">
          {/* <Switch>
            

            <Route exact path={props.match.url + "/responses"}>
            ff
            </Route>

           

            <Redirect from="*" to={props.match.url + "/summary"} />
          </Switch> */}

          {
            currentTrivia.isMessaging ? <Col sm={9}>
              {tab == 1 ? (
                <MessagingTriviaResultsSummary trivia={currentTrivia} />
              ) : tab === 2 ? (
                <MessagingTriviaResultsResponses trivia={currentTrivia} user={props.user} />
              ) : tab === 3 ? (
                <TriviaResultsInsights questions={currentTrivia.questions}
                  surveyId={currentTrivia._id}
                  allowAttempts={currentTrivia.allowAttempts}
                  currentTrivvy={currentTrivia}
                  setCurrentTrivia={props.setCurrentTrivia}
                  user={props.user.profile} />
              ) : (
                ""
              )}
            </Col> : <Col sm={9}>
              {tab == 1 ? (
                <TriviaResultsSummary
                  questions={currentTrivia.questions}
                  surveyId={currentTrivia._id}
                  allowAttempts={currentTrivia.allowAttempts}
                  currentTrivvy={currentTrivia}
                  setCurrentTrivia={props.setCurrentTrivia}
                  user={props.user.profile}
                />
              ) : tab === 2 ? (
                <TriviaResultsResponses
                  questions={currentTrivia.questions}
                  surveyData={currentTrivia}
                  allowAttempts={currentTrivia.allowAttempts}
                  numberOfAttempts={currentTrivia.numberOfAttempts}
                />
              ) : tab === 3 ? (
                <TriviaResultsInsights questions={currentTrivia.questions}
                  surveyId={currentTrivia._id}
                  allowAttempts={currentTrivia.allowAttempts}
                  currentTrivvy={currentTrivia}
                  setCurrentTrivia={props.setCurrentTrivia}
                  user={props.user.profile} />
              ) : (
                ""
              )}
            </Col>
          }

        </Row>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default withRouter(TriviaResultsComponent)
